module.exports = __webpack_public_path__ + "static/img/index_bk4_icon.4c368cc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index_bk4_icon.png
// module id = 2x6r
// module chunks = 4